import config from '../config';
import { useAuthStore } from '../stores/auth/auth.store';

export type RequestConfig = {
  endpoint: string;
  method?: 'GET' | 'POST' | 'PUT' | 'PATCH';
  body?: Record<string, any>;
};

export const makeApiRequest = (reqConfig: RequestConfig) => {
  const defaultConfig: RequestConfig = {
    method: 'GET',
    body: undefined,
    ...reqConfig
  };
  const authState = useAuthStore.getState();

  return fetch(`${config.apiUrl}${defaultConfig.endpoint}`, {
    method: defaultConfig.method,
    headers: {
      'content-type': 'application/json',
      authorization: authState.token ? `bearer ${authState.token}` : ''
    },
    body: defaultConfig.body ? JSON.stringify(defaultConfig.body) : undefined,
  });
};
